var map = {
	"./buffer-table/buffer-table.module": [
		"./src/app/buffer-table/buffer-table.module.ts",
		"buffer-table.module",
		"common"
	],
	"./change-buffer/change-buffer.module": [
		"./src/app/change-buffer/change-buffer.module.ts",
		"change-buffer.module",
		"common"
	],
	"./components/access-denied/access-denied.module": [
		"./src/app/components/access-denied/access-denied.module.ts",
		"access-denied.module"
	],
	"./components/versions-not-compatible/versions-not-compatible.module": [
		"./src/app/components/versions-not-compatible/versions-not-compatible.module.ts",
		"versions-not-compatible.module"
	],
	"./home/home.module": [
		"./src/app/home/home.module.ts",
		"home.module"
	],
	"./import-assortment/import-assortment.module": [
		"./src/app/import-assortment/import-assortment.module.ts",
		"import-assortment.module",
		"common"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"login.module"
	],
	"./marketing-purchases/marketing-purchases.module": [
		"./src/app/marketing-purchases/marketing-purchases.module.ts",
		"marketing-purchases.module",
		"common"
	],
	"./orders/orders.module": [
		"./src/app/orders/orders.module.ts",
		"orders.module",
		"common"
	],
	"./supply-schedule/supply-schedule.module": [
		"./src/app/supply-schedule/supply-schedule.module.ts",
		"supply-schedule.module",
		"common"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main